export default "__VITE_ASSET__hqrDpBHq__"